<template>
    <v-row justify="center" align="center">
        <v-col cols=12 class="pa-0" v-if="agreement_status === 'complete' || agreement_status === 'ready'">
            <v-row no-gutters>
                <v-col cols=6 class="ma-0 pa-0">
                    <v-btn
                        fab 
                        small
                        color="grey lighten-2"
                        class="mx-2"
                        elevation=0
                        @click="downloadAgreementPDF(detail)"
                        
                      >
                        <v-icon color="primary" large>mdi-download</v-icon>
                     </v-btn>
                </v-col>
                <v-col cols=6 class="ma-0 pa-0">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            fab 
                            small
                            color="grey lighten-2"
                            class="mx-2"
                            v-on="on"
                            elevation=0
                            @click="downloadAgreementDOCX(detail)"
                          >
                            <v-icon color="primary" large>mdi-file-document-edit-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Download Editable Template</span>
                    </v-tooltip>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols=12 class="pa-0" v-else-if="agreement_status === 'error'">
            <v-btn fab small color="grey lighten-2" class="mx-2" elevation=0 >
                <v-icon color="red" large>mdi-alert-circle-outline</v-icon>
            </v-btn>
        </v-col>
        <v-col cols=12 class="pa-0" v-else>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-progress-circular indeterminate color="primary" class="mr-2" v-on="on"></v-progress-circular>
                </template>
                <span>Generating Agreement PDF</span>
            </v-tooltip>
        </v-col>
    </v-row>
</template>

<script>
  import axios from 'axios';
  import {mapActions} from 'vuex';
  export default {
    
    data: () => ({
       agreement_status: '',
       intervalCreated: false,
       interval: null,
    }),  
      
    props: {
        status: [String],
        id: [ Number, String],
        detail: [Object],
    },
    
    mounted () {
        this.agreement_status = this.status;
        console.log('AGREEMENT STATUS')
        console.log(this.status)
    },
    
    beforeDestroy() {
        console.log('Destroying Watcher...')
        this.removeInterval();
    },
    
    computed: {
    },
    watch: {
        agreement_status: {
            handler: function(new_value) {
                if(new_value !== "complete" && new_value !== "error" && new_value !== 'ready'){
                    this.createInterval();
                } else {
                    this.removeInterval();
                }
            }
        }
    },
    methods: {
        ...mapActions(['downloadAgreementPDF', 'downloadAgreementDOCX']),
        
        createInterval(){
            console.log('createInterval');
            if(!this.intervalCreated){
                this.queueCheck();
                this.interval = setInterval(() => {
                    this.queueCheck()
                }, 3000);
            }
            this.intervalCreated = true;
        },
        
        queueCheck() {
            var count = 0
            
            let token = sessionStorage.getItem('token');
            let authToken = "Token "+token;
            let authHeader = {headers: {
                Authorization: authToken
            }};
            axios.get('/agreement/queue/?agreement_id='+ this.id, authHeader).then((res) => {
                console.log(res.data)
                this.agreement_status = res.data.queue_status
            })
            .catch(err => {
                console.log(err);
                this.agreement_status = 'error'
            })
            
            if(count === 20){
                this.agreement_status = 'error'
            }
            count += 1
        },
        removeInterval(){
            this.intervalCreated = false;
            clearInterval(this.interval);
        },
        uuidv4() {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
          });
        }
    },
    components: {}
  };
</script>

<style type="text/css" scoped>
    .border {
      border-style: solid !important;
    }
    .v-data-table__expanded__content{
        box-shadow: none;
    }
    .row_item {
        border-bottom: thin solid rgb(0,0,0,30%);
    }
</style>